import React from "react";
import Introductiontoiot from "../../../../../assets/learnersCourses/iotCourses/introductiontoInternetofThings.webp";
import Amazon from "../../../../../assets/learnersCourses/iotCourses/aWSIoTCertificationTraining.webp";
import Microsoft  from "../../../../../assets/learnersCourses/iotCourses/microsoftAzureIoTCertification.webp";
import Internet from "../../../../../assets/learnersCourses/iotCourses/ioTandEmbeddedSystemswithESP32.webp";
import SmartHome from "../../../../../assets/learnersCourses/iotCourses/pythonProgramming.webp";
import ESP32Arduino from "../../../../../assets/learnersCourses/iotCourses/masterESP32BluetoothandBLEHandsOnProjectsforIoTCommunication.webp";
import NodeMCUMATLAB from "../../../../../assets/learnersCourses/iotCourses/iotMATLAB.webp";
import NternetESP32Arduino from "../../../../../assets/learnersCourses/iotCourses/introductiontoInternetofThings.webp";
import NodeRed from "../../../../../assets/learnersCourses/iotCourses/masterNode-RedfromBasictoAdvanced.webp";
import BluetoothTechnology from "../../../../../assets/learnersCourses/iotCourses/mING TechnologiesinIndustrialIoT.webp";
import JavaScript from "../../../../../assets/learnersCourses/iotCourses/developingWebApplicationsforIoTUsingPythonandJavaScript.webp";
import SystemsProject from "../../../../../assets/learnersCourses/iotCourses/masterWIFIcommunication.webp";
import SmartusingESP32 from "../../../../../assets/learnersCourses/iotCourses/masteringMQTT.webp";
import IndustrialInternet from "../../../../../assets/learnersCourses/iotCourses/industrialInternetofThings.webp";

const courses = [
  {
    courseId: 1,
    courseTitle: "Introduction to Internet of Things",
    videoUrl: "",
    image: Introductiontoiot,
    Skills: "",
    completion: 0
  },
  {
    courseId: 2,
    courseTitle: "To Electronics and Circuit Design",
    videoUrl: "",
    image: Amazon,
    Skills: "",
    completion: 0
  },
  {
    courseId: 3,
    courseTitle: "Embedded Systems using ESP32 and ESP-IDF",
    videoUrl: "",
    image: Microsoft,
    Skills: "",
    completion: 0
  },
  {
    courseId: 4,
    courseTitle: "Embedded Systems and IoT using STM32",
    videoUrl: "",
    image: Internet,
    Skills: "",
    completion: 0
  },
  {
    courseId: 5,
    courseTitle: "Sensor Technology and Integration",
    videoUrl: "",
    image: SmartHome,
    Skills: "",
    completion: 0
  },
  {
    courseId: 6,
    courseTitle: "PCB Design and Manufacturing",
    videoUrl: "",
    image:  ESP32Arduino,
    completion: 0
  },
  {
    courseId: 7,
    courseTitle: "Python Programming",
    videoUrl: "", 
    image: NodeMCUMATLAB,
    completion: 0
  },
  {
    courseId: 8,
    courseTitle: "IoT and Embedded Systems with ESP32",
    videoUrl: "",
    image: NternetESP32Arduino,
    completion: 0
  },
  {
    courseId: 9,
    courseTitle: "IoT using Raspberry Pi and Python",
    videoUrl: "", 
    image: NodeRed,
    completion: 0
  },
  {
    courseId: 10,
    courseTitle: "Azure IoT Certification Training",
    videoUrl: "", 
    image: BluetoothTechnology,
    completion: 0
  },
  {
    courseId: 11,
    courseTitle: "AWS IoT Certification Training",
    videoUrl: "", 
    image: JavaScript,
    completion: 0
  },
  {
    courseId: 12,
    courseTitle: "IoT Data analysis using python",
    videoUrl: "", 
    image: SystemsProject,
    completion: 0
  },
  {
    courseId: 13,
    courseTitle: "Master ESP32, Bluetooth, and BLE",
    videoUrl: "", 
    image: SmartusingESP32,
    completion: 0
  },
  {
    courseId: 14,
    courseTitle: "Master WIFI communication",
    videoUrl: "",
    image: IndustrialInternet,
    completion: 0
  },
  {
    courseId: 15,
    courseTitle: "Long distance wireless networks: GSM, Lora, NBIOT",
    videoUrl: "",
    image: IndustrialInternet,
    completion: 0
  },
  {
    courseId: 16,
    courseTitle: "Master MQTT",
    videoUrl: "",
    image: IndustrialInternet,
    completion: 0
  },
  {
    courseId: 17,
    courseTitle: "Generative AI for hardware Engineers: Flux.ai",
    videoUrl: "",
    image: IndustrialInternet,
    completion: 0
  }
];

const Start = () => {


  return (
    <div>
    <div className="mylearningpaths">
      <h1 className="mylearningpaths-h1">IoT Hardware Engineer</h1>
      <p className="mylearningpaths-p">Courses</p>
      <div className="mylearningpath">
        <div className="Wrapper-sc-fvyqwl-1 iZEyIQ AssignmentList__Timeline-sc-1t9paan-2 chIzFH">
          <ul className="Circle-sc-fvyqwl-1">
            {courses.map((course, index) => (
              <li key={course.courseId}>
                <div className="learningpath-courses-dashboard">
                  <div>
                  <img src={course.image} alt={course.courseTitle} className="smart-shoe-development" />
                  </div>
                  <div>
                  <p className={`pythoncourses${course.courseId}`} style={{paddingTop : "10px",}}>
                  {index + 1}. {course.courseTitle}
                  </p>
                  <p className="learningpath-courses-dashboard-skills">Skills: <span className="learningpath-courses-dashboard-skills-span">{course.Skills}</span></p>
                  <div className="learningpath-courses-dashboard-progressbar">
                  <p className="learningpath-courses-dashboard-skills-completed">{course.completion}%</p>
                  </div>
                  <div>
                     <div>
                    {course.completion === 100 ? (
                      <button className="learningpath-courses-dashboard-button-start">Download Certificate</button>
                    ) : course.completion >= 10 ? (
                      <button  className="learningpath-courses-dashboard-button-start">Continue Learning</button>
                    ) : (
                      <button className="learningpath-courses-dashboard-button-start">Start Learning</button>
                    )}
                  </div>
                  </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <p className="mylearningpaths-p">Recommended Projects</p>
    </div>
  </div>
);
};

export default Start;